import React from 'react';
import { FormControlLabel, Radio, TextField } from '@mui/material';
import {
  OtherOptionInputWrapper,
  RadioOptionsGroup,
  RadioOptionWrapper,
} from '../FormPreview.styles';
import { BaseInputProps } from './types';

export const RadioInput: React.FC<BaseInputProps> = ({
  currentQuestion,
  answers,
  dispatch,
  inlinePlacement,
  textInputPlaceholder,
}) => {
  const selectedRadioOption = answers[currentQuestion.id]?.radioOption;
  const otherOptionText = answers[currentQuestion.id]?.otherOptionText || '';

  return (
    <RadioOptionsGroup
      $inlinePlacement={inlinePlacement}
      data-testid="form-preview-radio-group"
    >
      {currentQuestion.options?.map((option) => {
        const isOtherOption = option.isOtherOption;
        const isSelected = selectedRadioOption === option.id;

        return (
          <div key={option.id}>
            <RadioOptionWrapper>
              <FormControlLabel
                control={
                  <Radio
                    id={`preview-radio-${option.id}`}
                    checked={isSelected}
                    onChange={() =>
                      dispatch({
                        type: 'SET_RADIO',
                        questionId: currentQuestion.id,
                        payload: option.id,
                      })
                    }
                    data-testid={`form-preview-radio-option-${option.id}`}
                  />
                }
                label={isOtherOption ? option.text.split(' (')[0] : option.text}
                sx={{ width: '100%', margin: 0 }}
              />
            </RadioOptionWrapper>
            {isOtherOption && isSelected && (
              <OtherOptionInputWrapper>
                <TextField
                  fullWidth
                  value={otherOptionText}
                  onChange={(e) =>
                    dispatch({
                      type: 'SET_OTHER_TEXT',
                      questionId: currentQuestion.id,
                      payload: e.target.value,
                    })
                  }
                  placeholder={textInputPlaceholder}
                  slotProps={{
                    htmlInput: {
                      'data-testid': `form-preview-radio-other-input-${option.id}`,
                    },
                  }}
                />
              </OtherOptionInputWrapper>
            )}
          </div>
        );
      })}
    </RadioOptionsGroup>
  );
};
